import { IHttpClient } from "../../../lib/http";
import { Image } from "../../shared/widgets/ImageManager";
import { MarketingManagerEntity } from "../domain/marketingManager.entity";

export enum MarketingMediaType {
  DESKTOP = "DESKTOP",
  MOBILE = "MOBILE",
}

export interface MarketingImageDTO {
  id: string;
  desktopImage?: {
    id: string;
    filename: string;
    url: string;
  };
  mobileImage?: {
    id: string;
    filename: string;
    url: string;
  };
  startDate?: string;
  endDate?: string;
  redirectUrl?: string;
}

export function imageFromDTO(dto?: { id: string; filename: string; url: string }): Image[] {
  if (!dto || !dto.url) {
    return [];
  }
  return [
    Object.assign(new File([""], dto.filename), {
      id: dto.id,
      url: dto.url,
      filename: dto.filename,
    } as Pick<Image, "id" | "url" | "filename">),
  ];
}

function mapDTOToEntity(dto: MarketingImageDTO): MarketingManagerEntity {
  return MarketingManagerEntity.create({
    id: dto.id,
    desktopImages: imageFromDTO(dto.desktopImage),
    mobileImages: imageFromDTO(dto.mobileImage),
    startDate: dto.startDate ?? undefined,
    endDate: dto.endDate ?? undefined,
    redirectUrl: dto.redirectUrl ?? undefined,
  });
}

export async function getMarketingImage(httpClient: IHttpClient): Promise<MarketingManagerEntity> {
  const dto = await httpClient.get<MarketingImageDTO>("/v1/marketing/login-image");
  return mapDTOToEntity(dto);
}

export async function updateMarketingImage(
  httpClient: IHttpClient,
  entity: MarketingManagerEntity
): Promise<void> {
  await httpClient.put("/v1/marketing/login-image", {
    startDate: entity.startDate ?? null,
    endDate: entity.endDate ?? null,
    redirectUrl: entity.redirectUrl ?? null,
  });
}

export async function uploadMarketingImage(
  httpClient: IHttpClient,
  mediaType: MarketingMediaType,
  imageData: Image
): Promise<void> {
  const formData = new FormData();
  formData.append("image", imageData);
  formData.append("attribute", mediaType);
  await httpClient.post(`/v1/marketing/login-image/upload`, formData);
}

export async function deleteMarketingImage(
  httpClient: IHttpClient,
  mediaType: MarketingMediaType
): Promise<void> {
  await httpClient.delete(`/v1/marketing/login-image/${mediaType}`);
}

export async function getActiveMarketingImage(
  httpClient: IHttpClient
): Promise<MarketingImageDTO | null> {
  return httpClient.get<MarketingImageDTO | null>("/v1/marketing/login-image/active");
}
